'use client'

import './ProductsHistory.scss'
import ProductCard from '@/entities/ProductCard'
import {
    AddToCart,
    AddToPreferences,
    QuickView,
} from '@/features/productSearch/ProductCardActions'
import { useGetCartItemsQuery } from '@/shared/api-rtk'
import { useSelector } from 'react-redux'

export const ProductsHistory = ({ currentProductId }) => {
    const { products } = useSelector((state) => state.productHistory)

    if (products.length <= 1) return

    const { data: productsInCart, isLoading } = useGetCartItemsQuery()

    let isInWiewd = false
    let currentIndex = 0
    for (let index = 0; index < products.length; index++) {
        const element = products[index]
        if (element.product_id === currentProductId) {
            isInWiewd = true
            currentIndex = index
            break
        }
    }

    return (
        <div className={'ProductsHistory'}>
            <h2>Вы смотрели</h2>
            <div className={'items-container'}>
                {products.map((item, i) => {
                    if (i === 0 && !isInWiewd) return
                    if (isInWiewd && i === currentIndex) return
                    return (
                        <ProductCard
                            key={item.product_id}
                            {...item}
                            product_id={item.product_id}
                        >
                            <QuickView productId={item.product_id} />
                            <AddToPreferences
                                item={item}
                                productId={item.product_id}
                            />
                            <AddToCart
                                item={item}
                                productId={item.product_id}
                                cartContains={productsInCart?.data?.includes(
                                    item?.product_id
                                )}
                            />
                        </ProductCard>
                    )
                })}
            </div>
        </div>
    )
}
